// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_7e-0";
export var optionCard = "_7e-1";